/* Built In Imports */
import { useEffect, useState } from 'react';

/* External Imports */
import {
  Box,
  Flex,
  Heading,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Text,
  useDisclosure,
} from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';
import YouTube from 'react-youtube';

/* Internal Imports */
/* Components */
import StructuredTextParser from '@app-ila/components/Utility/StructuredTextParser';
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';
import config from '@config';

/* Styles */
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css';

/**
 * Renders InsightVideo component
 * @param {Object} embedContent
 * @returns {ReactElement}
 */
const GenSaVideo = ({ sectionContent }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <Box 
        py={{ base: '30px', md: '80px', xl: '100px' }}
    >
      <Box
        mx="auto"
        maxW={{
          base: '100%',
          md: '768px',
          lg: '1024px',
          xl: 1102,
          '2xl': '1102px',
        }}
        width="100%"
        background={`url(${config.imgPath}/d/46272/1692760406-bg-yellow.jpg) no-repeat`}
        backgroundPosition="center"
        backgroundSize="100% 90%"
        height={{ base: 'auto', md: 'auto', lg: '500px', xl: '464px' }}
        paddingBottom={{ base: '50px', sm:"50px",  md: '50px' }}
        mt={{base:"100px", sm:"100px", md:"0px", lg:"0px"}}
      >
        <Box
          maxW={{
            base: '100%',
            sm: '540px',
            md: '720px',
            lg: '960px',
            xl: '1102px',
            '2xl': '1102px',
          }}
          mx="auto"
          w="100%"
          backgroundImage=""
          backgroundPosition="center"
          backgroundSize="cover"
        >
          <Box>
            <Flex
              alignItems={{base:"center", md:"start", lg:"start"}}
              justifyContent="center"
              flexDir={{ base: 'column-reverse', md: 'row' }}
              h="auto"
              flexWrap="wrap"
            >
              <Box
                w={{ base: '100%', md: '50%' }}
                mt={{ base: '50px', md: '60px' }}
                px={{ base: '20px', md: '0' }}
              >
                <Box
                    color={"#FFF"}
                    fontSize={"24px"}
                    w={{ base: '100%', md: '88%' }}
                    mx="auto"
                    lineHeight="160%"
                    fontWeight="600"
                    fontFamily="var(--FedraSansStd-book), sans-serif"
                 >
                 {sectionContent[0]?.titleText}
                </Box>
                <Box
                  color="#FFF"
                  fontSize="18px"
                  fontStyle="normal"
                  fontWeight="500"
                  lineHeight="160%"
                  fontFamily="var(--FedraSansStd-book), sans-serif"
                  w={{ base: '100%', md: '88%' }}
                  mx="auto"
                  mt={{ md: '20px', base: '10px' }}
                >
                  <StructuredTextParser
                    str={render(sectionContent?.[1]?.body)}
                    fontSize={'18px'}
                    color="#FFF"
                    fontStyle="normal"
                    fontWeight="500"
                    mt={{ md: '50px', base: '40px' }}
                    lineHeight="160%"
                    fontFamily="var(--FedraSansStd-book), sans-serif"
                    //className="textWhite"
                  />
                </Box>
              </Box>
              <Box
                w={{ base: '100%', md: '50%' }}
                maxW={{ base: '313px', lg: '354px' }}
                h={{ base: 'auto', md: 'auto', lg: '280px' }}
                marginTop={{base:"-70px", sm:"-70px", md:"-20px", lg:"-30px"}}
                padding={"60px"}
                bg="#FEF3E3"
                //justifyContent="center"
                alignItems="start"
                //textAlign="center"
                //objectFit="container"
                //position={"flex"}
              >
                <LazyLoadImageComponent
                  src={sectionContent[2]?.image?.url}
                  h="auto"
                  loading="eager"
                  alt={sectionContent?.[2]?.image?.alt || 'Insight'}
                  maxW={{ base: '90%', xl: '354px' }}
                />
              </Box>
            </Flex>
          </Box>
          <style global jsx>
            {`
              .insightVideo {
                height: 100%;
              }
              .insightVideo iframe {
                height: inherit;
              }
              .closeButton:hover {
                background: #ffffff !important;
                color: black !important;
              }
              .textWhite p {
                // font-family: 'var(--FedraSansStd-book)', sans-serif;
              }
              .textWhite p strong {
                // font-family: 'var(--FedraSansStd-medium)', sans-serif;
                font-weight: 500;
              }
              @media only screen and (max-width: 550px) {
                .insightVideo {
                  width: 100%;
                  height: 100%;
                }
                .insightVideo iframe {
                  width: 100%;
                  height: 100%;
                }
              }
            `}
          </style>
        </Box>
      </Box>
    </Box>
  );
};

export default GenSaVideo;
